import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import Avatar from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Avatar';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = () => ({
  root: {
    width: 80,
    height: 80,
  },
});

const ClientAvatar = ({
  className,
  classes,
  searchResultResource,
}) => {
  return (
    <Avatar
      className={classNames(classes.root, className)}
      src={searchResultResource.relationship(fr.relationships.icon.name)?.link('related')?.url()}
    />
  );
};

ClientAvatar.defaultProps = {
  className: '',
};

ClientAvatar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  searchResultResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(ClientAvatar);
